import React from 'react'
import PropTypes from 'prop-types'

// Simple loading skeleton lines
const SkeletonLine = ({ width = '100%', height = '16px', className = '' }) => (
  <div 
    className={`bg-bg-tertiary animate-pulse rounded ${className}`}
    style={{ width, height }}
  />
)

// Main LoadingSkeleton component
const LoadingSkeleton = ({ type = 'default', lines = 3 }) => {
  if (type === 'agent') {
    return (
      <div className="space-y-4 p-6">
        <SkeletonLine width="60%" height="24px" />
        <SkeletonLine width="100%" height="16px" />
        <SkeletonLine width="80%" height="16px" />
        <SkeletonLine width="90%" height="16px" />
      </div>
    )
  }

  return (
    <div className="space-y-3 p-4">
      {Array.from({ length: lines }).map((_, index) => (
        <SkeletonLine 
          key={index}
          width={index === lines - 1 ? '70%' : '100%'}
          height="16px"
        />
      ))}
    </div>
  )
}

SkeletonLine.propTypes = {
  width: PropTypes.string,
  height: PropTypes.string,
  className: PropTypes.string
}

LoadingSkeleton.propTypes = {
  type: PropTypes.oneOf(['default', 'agent']),
  lines: PropTypes.number
}

export default LoadingSkeleton